import { useLayoutEffect, useMemo, useRef } from 'react';

export default function useLatestCallback(callback) {
  const latestCallbackRef = useRef();
  useLayoutEffect(() => {
    latestCallbackRef.current = callback;
  }, [callback]);

  const latestCallback = useMemo(() => {
    return (...args) => {
      return latestCallbackRef.current(...args);
    };
  }, []);

  return latestCallback;
}
